import { render, staticRenderFns } from "./SetorTarik.vue?vue&type=template&id=fdbedad6&scoped=true"
import script from "./SetorTarik.vue?vue&type=script&lang=js"
export * from "./SetorTarik.vue?vue&type=script&lang=js"
import style0 from "./SetorTarik.vue?vue&type=style&index=0&id=fdbedad6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdbedad6",
  null
  
)

export default component.exports